/**
 * Owner: Masa Bayu
 * File: private-author-mobile-labels.ts
 * Date:Time: 2026-10-19 04:30
 * Description: Label halaman mudah alih PRIVAT §390 — en + ms (pola locale
 *   §381); mockup Owner ialah variasi ms.
 */

import type { MarketplaceLanguage } from '../../home/marketplace/marketplace-locale';

export type PrivateMobileViewId = 'home' | 'buku' | 'penerbitan' | 'sales' | 'analytics';
export type PrivateMobileBottomId = 'home' | 'buku' | 'penerbitan' | 'notif' | 'profil';
export type PrivateMobileShortcut =
  'upload' | 'bookPlus' | 'megaphone' | 'report' | 'price' | 'receipt';
/** Pil Buku Saya §467-C — hanya keadaan sebenar hub (tersedia / belum harga). */
export type PrivateMobilePill = 'all' | 'live' | 'unpriced';

export interface PrivateAuthorMobileLabels {
  readonly bottomAria: string;
  readonly bottom: Readonly<Record<PrivateMobileBottomId, string>>;
  readonly menuAria: string;
  readonly menuCloseAria: string;
  readonly searchAria: string;
  readonly backAria: string;
  readonly statDetail: string;
  readonly prestasiTitle: string;
  readonly prestasiMonthAria: string;
  readonly salesLabel: string;
  readonly ordersLabel: string;
  readonly shortcutsTitle: string;
  readonly railTitle: string;
  readonly railSeeAll: string;
  readonly notifTitle: string;
  readonly booksSub: string;
  readonly booksSearchAria: string;
  readonly booksSearchPlaceholder: string;
  readonly filterAria: string;
  readonly filterToast: string;
  readonly promoToast: string;
  readonly pills: Readonly<Record<PrivateMobilePill, string>>;
  readonly emptyLive: string;
  readonly emptyUnpriced: string;
  readonly emptySearch: string;
  readonly ctaTitle: string;
  readonly ctaButton: string;
  readonly fabAria: string;
  readonly rowMenuAria: string;
}

export const PRIVATE_AUTHOR_MOBILE_LABELS: Readonly<
  Record<MarketplaceLanguage, PrivateAuthorMobileLabels>
> = Object.freeze({
  en: Object.freeze({
    bottomAria: 'Author dashboard tabs',
    bottom: Object.freeze({
      home: 'Home',
      buku: 'My Books',
      penerbitan: 'Publishing',
      notif: 'Notifications',
      profil: 'Profile',
    }),
    menuAria: 'Open dashboard menu',
    menuCloseAria: 'Close dashboard menu',
    searchAria: 'Search the marketplace',
    backAria: 'Back to dashboard home',
    statDetail: 'See Detail',
    prestasiTitle: 'Monthly Performance',
    prestasiMonthAria: 'Chart month',
    salesLabel: 'Total Sales',
    ordersLabel: 'Orders',
    shortcutsTitle: 'Quick Actions',
    railTitle: 'My Books',
    railSeeAll: 'See All',
    notifTitle: 'Notifications',
    booksSub: 'Manage all your books in one place.',
    booksSearchAria: 'Search my books',
    booksSearchPlaceholder: 'Search my books…',
    filterAria: 'Filter books',
    filterToast: 'Book filters are not available yet.',
    promoToast: 'Promo campaigns are not available yet.',
    pills: Object.freeze({
      all: 'All',
      live: 'On Sale',
      unpriced: 'No Price',
    }),
    emptyLive: 'No publication is priced for sale yet.',
    emptyUnpriced: 'Every publication already has a price.',
    emptySearch: 'No books match your search.',
    ctaTitle: 'Want to publish a new book?',
    ctaButton: '+ Upload Manuscript',
    fabAria: 'Upload a new manuscript',
    rowMenuAria: 'Book options',
  }),
  ms: Object.freeze({
    bottomAria: 'Tab dashboard author',
    bottom: Object.freeze({
      home: 'Home',
      buku: 'Buku Saya',
      penerbitan: 'Penerbitan',
      notif: 'Notifikasi',
      profil: 'Profil',
    }),
    menuAria: 'Buka menu dashboard',
    menuCloseAria: 'Tutup menu dashboard',
    searchAria: 'Cari di pasar',
    backAria: 'Kembali ke laman utama',
    statDetail: 'Lihat Detail',
    prestasiTitle: 'Prestasi Bulanan',
    prestasiMonthAria: 'Bulan carta',
    salesLabel: 'Jumlah Jualan',
    ordersLabel: 'Pesanan',
    shortcutsTitle: 'Pintasan Pantas',
    railTitle: 'Buku Saya',
    railSeeAll: 'Lihat Semua',
    notifTitle: 'Notifikasi',
    booksSub: 'Urus semua buku anda di satu tempat.',
    booksSearchAria: 'Cari buku saya',
    booksSearchPlaceholder: 'Cari buku saya…',
    filterAria: 'Penapis buku',
    filterToast: 'Penapis buku belum tersedia.',
    promoToast: 'Kempen promosi belum tersedia.',
    pills: Object.freeze({
      all: 'Semua',
      live: 'Dijual',
      unpriced: 'Tiada Harga',
    }),
    emptyLive: 'Belum ada terbitan yang diberi harga untuk dijual.',
    emptyUnpriced: 'Semua terbitan sudah mempunyai harga.',
    emptySearch: 'Tiada buku yang sepadan dengan carian.',
    ctaTitle: 'Ingin terbitkan buku baharu?',
    ctaButton: '+ Muat Naik Manuskrip',
    fabAria: 'Muat naik manuskrip baharu',
    rowMenuAria: 'Pilihan buku',
  }),
});
